import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Instagram, Youtube, Facebook } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function Footer() {
  const {
    ref,
    isVisible
  } = useScrollReveal({
    threshold: 0.1
  });
  return <footer className="bg-richBlack border-t border-white/5 pt-16 md:pt-24 pb-12 relative overflow-hidden" data-id="element-40">
      {/* Subtle top gradient line for premium feel */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-[1px] bg-gradient-to-r from-transparent via-gold/20 to-transparent" data-id="element-41" />

      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-42">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 mb-20" data-id="element-43">
          {/* Left Section */}
          <div className="md:col-span-4 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-44">
            <a href="#" className="inline-block mb-6" aria-label="Volver al inicio" data-id="element-45">
              <span className="font-montserrat font-extrabold tracking-[0.18em] text-xl md:text-2xl neon-text-static" data-id="element-46">
                <span className="text-warmWhite" data-id="element-47">CRECE</span>
                <span className="text-gold" data-id="element-48">ELITE</span>
              </span>
            </a>
            <p className="text-mutedGray font-montserrat font-light leading-relaxed text-sm md:text-base md:pr-4" data-id="element-49">
              Un sistema de crecimiento basado en cinco fundamentos: cuerpo,
              mente, espíritu, relaciones y finanzas.
            </p>
          </div>

          {/* Center Section */}
          <div className="md:col-span-3 md:col-start-6 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-50">
            <h4 className="text-sm font-montserrat font-semibold tracking-widest text-warmWhite uppercase mb-6" data-id="element-51">
              Explorar
            </h4>
            <ul className="space-y-4" data-id="element-52">
              {[{
              name: 'Inicio',
              href: '#'
            }, {
              name: 'Los 5 Fundamentos',
              href: '#pilares'
            }, {
              name: 'Guía Gratuita',
              href: '#guia'
            }, {
              name: 'Ebook CRECEELITE',
              href: '#libro'
            }, {
              name: 'Guías Semanales',
              href: '#guias'
            }].map(link => <li key={link.name} data-id="element-53">
                  <a href={link.href} className="text-mutedGray hover:text-gold transition-colors duration-300 font-montserrat text-sm tracking-wide" data-id="element-54">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Right Section */}
          <div className="md:col-span-4 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-55">
            <h4 className="text-sm font-montserrat font-semibold tracking-widest text-warmWhite uppercase mb-6" data-id="element-56">
              Recibe contenido de crecimiento
            </h4>
            <form className="mb-8 w-full max-w-sm" onSubmit={e => e.preventDefault()} data-id="element-57">
              <div className="flex flex-col sm:flex-row gap-3" data-id="element-58">
                <input type="email" placeholder="Tu correo electrónico" className="bg-transparent border border-white/10 px-4 py-3 text-sm text-warmWhite font-montserrat focus:outline-none focus:border-gold transition-colors w-full placeholder:text-mutedGray/50" required data-id="element-59" />
                <button type="submit" className="w-full sm:w-auto bg-gold text-richBlack px-6 py-3 font-montserrat font-semibold text-sm hover:bg-goldLight transition-colors whitespace-nowrap" data-id="element-60">
                  Suscribirme
                </button>
              </div>
            </form>

            <div className="flex gap-6" data-id="element-61">
              <a href="#" className="text-mutedGray hover:text-gold transition-colors duration-300" aria-label="Instagram" data-id="element-62">
                <Instagram className="w-5 h-5" data-id="element-63" />
              </a>
              <a href="#" className="text-mutedGray hover:text-gold transition-colors duration-300" aria-label="YouTube" data-id="element-64">
                <Youtube className="w-5 h-5" data-id="element-65" />
              </a>
              <a href="#" className="text-mutedGray hover:text-gold transition-colors duration-300" aria-label="Facebook" data-id="element-66">
                <Facebook className="w-5 h-5" data-id="element-67" />
              </a>
            </div>
          </div>
        </motion.div>

        {/* Bottom Line */}
        <motion.div initial={{
        opacity: 0
      }} animate={isVisible ? {
        opacity: 1
      } : {}} transition={{
        duration: 1,
        delay: 0.4
      }} className="border-t border-white/5 pt-8 flex flex-col items-center md:flex-row md:justify-between gap-4" data-id="element-68">
          <p className="text-mutedGray font-montserrat text-xs tracking-wide" data-id="element-69">
            © 2026 CRECEELITE. Todos los derechos reservados.
          </p>
        </motion.div>
      </div>
    </footer>;
}